import $ from 'jquery';
import PageApp from 'pageApp';
import { HORIZONTAL, VERTICAL, PAGE_SHOWN_EVENT, LAST_PAGE_EVENT } from '@component/product-pool-media';
import ProsTrackingHelper from '../util/ProsTrackingHelper';
import Panel from './Panel';
import ProsEvents from '../util/ProsEvents';
import NavigationView from './NavigationView';
import ProsEventHandler from '../events/ProsEventHandler';
import CarouselViewDecider from '../util/CarouselViewDecider';
import RecommendationStore from '../store/RecommendationStore';

export default class Carousel extends Panel {
  dispatchPixelEvent({ pageIdsPos, currentPage, config }) {
    const that = this;
    /* istanbul ignore next */
    const scrollListener = (view) => {
      const windowTop = $(window).scrollTop() + $(window).height();
      const prosPanelTop = (view.$el.offset() && view.$el.offset().top) ? view.$el.offset().top : 0;
      if (windowTop > prosPanelTop) {
        view.prosEventHandler.sendPixelEvent({
          pageIdsPos, currentPage, config,
        });
        view.pixelEventDispatched = true;
      }
    };
    /* istanbul ignore next */
    if (this.properties.pixelPresentedEnabled) {
      scrollListener(this);

      if (!this.pixelEventDispatched) {
        $(window).scroll(() => {
          scrollListener(that);
        });
      }
    }
  }
  registerEvents() {
    super.registerEvents();
    this.panel.on(LAST_PAGE_EVENT, () => {
      this.nextPage();
    });
    this.panel.on(PAGE_SHOWN_EVENT, ({
      pageIdsPos, current: currentPage, max: maxPage, childPerPage, lastItemShown, totalItems,
    }) => {
      const { config } = this;
      this.trigger(ProsEvents.PAGE_INFORMATION, {
        currentPage, maxPage, childPerPage, lastItemShown, totalItems,
      });

      this.initNavigation(currentPage, childPerPage);

      this.dispatchPixelEvent({ pageIdsPos, currentPage, config });
    });
  }

  initNavigation(currentPage, childPerPage) {
    if (!this.navigationView) {
      this.navigationView = NavigationView.init({ pageInfo: { currentPage, childPerPage }, prosPanel: this });
    }
  }

  registerEventsOnRender() {
    ProsEventHandler.registerChevronAnalytics(this.panel.carouselView);

    this.panel.carouselView.on('swipe_event', () => {
      ProsEventHandler.triggerChevronAnalytics();
    });

    const { config } = this;

    const workflow = RecommendationStore.getWorkflow(config, config.zone);

    PageApp.channel.on(`doSizing-${workflow}`, () => {
      this.panel.carouselView.doSizing();
    });
  }

  createPanel({ items }) {
    const { autoScrollTime } = this.config;
    let autoScrollConfig = {};
    if (autoScrollTime) {
      autoScrollConfig = {
        autoplay: true,
        autoplayInterval: autoScrollTime,
      };
    }
    const config = Object.assign({}, this.config, {
      carouselType: this.config.orientation === 'vertical' ? VERTICAL : HORIZONTAL,
    }, autoScrollConfig);

    this.addClasses();

    this.panel = CarouselViewDecider.getCarouselView(this.config, this.properties, {
      el: this.config.element,
      model: this.getPanelData(items),
      childView: this.thumbnailView,
      config,
    });
  }

  addClasses() {
    const $element = $(this.config.element);
    let classesToAdd = 'pros-factory-carousel';
    if (this.properties.prosZoneRedesignEnabled && this.config.orientation === HORIZONTAL) {
      classesToAdd = `${classesToAdd} pros-zone-redesign-enabled`;
    } else {
      classesToAdd = `${classesToAdd} pros-zone-redesign-disabled`;
    }
    if (this.config.orientation === VERTICAL) {
      classesToAdd = `${classesToAdd} vertical`;
    } else {
      classesToAdd = `${classesToAdd} horizontal`;
    }
    $element.addClass(classesToAdd);
  }

  nextPage() {
    this.pagination.currentPage += 1;
    const { currentPage, pageSize } = this.pagination;
    this.thumbnailCollection.loadPage(currentPage, pageSize)
      .then((thumbs) => {
        const { requester, zone } = this.config;
        const updatedThumbs = ProsTrackingHelper.addAnalyticsInfo({
          requester, zone, pageSize, currentPage, thumbs,
        });
        this.collectionBuffer.reset(updatedThumbs, { silent: true });
        this.panel.addNextPageItems(this.collectionBuffer);
        if (this.properties && this.properties.dbedDomSizeReductionEnabled) {
          this.updateThumbs();
        }
        this.onScroll(thumbs);
      }).catch(() => {
        this.panel.setEndOfData(true);
      });
  }

  triggerNextEvent() {
    this.panel.carouselView.next();
  }

  triggerPrevEvent() {
    this.panel.carouselView.prev();
  }

  moveToFirstPage() {
    this.panel.moveToFirstPage();
  }

  updateThumbs() {
    // get styles from first carousel item
    const self = this;
    const thumbnailWidth = self.panel.$el.find('ul.carousel li:first').attr('style');
    self.panel.$el.find('ul.carousel li:not([style])').each((index, element) => {
      $(element).attr('style', thumbnailWidth);
    });
    self.panel.carouselItems = self.panel.$el.find('ul.carousel li');
  }
}
